import lapdev from '../../lapdev';

export function resetPassword(email) {
  return lapdev.post('auth/reset-password', { email });
}
